<div class='footer'>
  <h4 *ngIf='showPrice'>Estimation for current configuration: {{ priceAmount | currency }}</h4>
  <h4 *ngIf='!showPrice'></h4>
  <div class='actions'>
    <davinci-button (click)='leftClicked()' [disabled]='left.disabled'>{{left.text}}</davinci-button>
    <davinci-button (click)='rightClicked()' [disabled]='right.disabled'>{{right.text}}</davinci-button>
  </div>
</div>
